import { DialogActionsProps } from '@mui/material/DialogActions';

import { ModalFooter } from './ContentModalFooter.styles';

function ContentModalFooter(props: DialogActionsProps) {
  const { children, ...rest } = props;

  return <ModalFooter {...rest}>{children}</ModalFooter>;
}

export default ContentModalFooter;
